import React from 'react'
import {
  Container,
  Heading,
  Text,
  Box,
  Divider,
  VStack
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const Terms = () => {
  const { t } = useTranslation()

  return (
    <Container maxW="container.lg" py={2}>
      <Text mb={4}>
        {t(
          '본 약관은 회사(이하 “회사”라 한다)가 제공하는 코인선물 자동매매 봇 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.'
        )}
      </Text>

      <Divider my={4} />

      <VStack spacing={6} align="stretch">
        {/* 제1조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제1조 (목적)')}
          </Heading>
          <Text>
            {t(
              '본 약관은 회사가 제공하는 코인선물 자동매매 봇 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.'
            )}
          </Text>
        </Box>

        {/* 제2조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제2조 (정의)')}
          </Heading>
          <Text mb={1}>
            {t('1.')} <strong>{t('회원')}</strong>:{' '}
            {t('본 약관에 동의하고 서비스 이용계약을 체결한 자를 말합니다.')}
          </Text>
          <Text mb={1}>
            {t('2.')} <strong>{t('서비스')}</strong>:{' '}
            {t(
              '회사가 제공하는 코인선물 자동매매 봇 운영 및 관련 서비스를 의미합니다.'
            )}
          </Text>
          <Text mb={1}>
            {t('3.')} <strong>{t('거래')}</strong>:{' '}
            {t('회원이 연동한 가상자산 거래소 계정을 통해 수행되는 선물·마진 등 매매 행위를 말합니다.')}
          </Text>
          <Text mb={1}>
            {t('4.')} <strong>{t('손실')}</strong>:{' '}
            {t('회원이 서비스를 이용함에 따라 발생하는 모든 종류의 자산 손실 및 이와 관련된 경제적 손해를 의미합니다.')}
          </Text>
          <Text>
            {t('5.')} <strong>{t('카피트레이딩(리딩)')}</strong>:{' '}
            {t('특정 회원 또는 제3자의 전략·신호·포지션을 전부 또는 일부 따라 하거나 이를 공유·권유하는 행위를 말합니다.')}
          </Text>
        </Box>

        {/* 제3조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제3조 (회원가입 및 이용계약의 성립)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회원가입은 회사가 정한 절차에 따라 신청하며, 회사의 승낙 후 이용계약이 성립됩니다.')}
          </Text>
          <Text mb={1}>
            {t('2. 회사는 회원가입 신청 시 제공된 정보의 진실성과 정확성을 확인할 권리가 있으며, 필요 시 추가 서류 제출을 요청할 수 있습니다.')}
          </Text>
          <Text>
            {t('3. 만 19세 미만이거나 관련 법령상 파생상품 거래가 제한된 자는 가입이 제한될 수 있습니다.')}
          </Text>
        </Box>

        {/* 제4조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제4조 (서비스의 제공 및 변경)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회사는 회원에게 코인선물 자동매매 봇 운영 서비스를 제공합니다.')}
          </Text>
          <Text mb={1}>
            {t('2. 서비스의 구체적인 내용, 운영 방식, 수수료 및 기타 조건은 별도 공지 및 안내문을 통해 제공됩니다.')}
          </Text>
          <Text>
            {t('3. 회사는 운영상·기술상의 필요에 따라 서비스의 내용을 변경하거나 일시 중단할 수 있으며, 이 경우 사전에 회원에게 공지합니다. 다만 긴급한 사유가 있는 경우 사후 공지할 수 있습니다.')}
          </Text>
        </Box>

        {/* 제5조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제5조 (회원의 의무)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회원은 본인의 계정 및 비밀번호를 안전하게 관리할 책임이 있으며, 이를 제3자에게 제공해서는 안 됩니다.')}
          </Text>
          <Text mb={1}>
            {t('2. 회원은 서비스 이용 시 관련 법령 및 본 약관을 준수해야 하며, 위반 시 회사는 서비스 이용 제한 또는 계약 해지 등의 조치를 취할 수 있습니다.')}
          </Text>
          <Text>
            {t('3. 회원은 서비스의 역분석, 역컴파일, 크롤링, 비정상적 API 호출 등 회사의 정상적인 서비스 제공을 방해하는 행위를 하여서는 안 됩니다.')}
          </Text>
        </Box>

        {/* 제6조 - 손실/면책 + 카피트레이딩 면책 보강 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제6조 (손실에 대한 책임 및 면책사항)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회원은 본 서비스를 이용하여 이루어지는 모든 거래의 결과에 대해 전적으로 본인의 책임을 집니다.')}
          </Text>
          <Text mb={1}>
            {t('2. 회사는 회원이 서비스를 이용함에 있어 발생한 거래 손실, 수익 손실 및 기타 모든 경제적 손해에 대해 어떠한 책임도 지지 않습니다.')}
          </Text>
          <Text mb={1}>
            {t('3. 특히, 회사의 서버 오류, 시스템 장애, 통신 장애, 해킹 등 기술적 문제로 인해 발생한 손실에 대해서도 회사는 책임을 지지 않습니다.')}
          </Text>
          <Text mb={1}>
            {t('4. 회원은 서비스 이용 전, 본인의 투자 판단에 따른 위험 부담을 충분히 인지하고 이용하여야 하며, 이와 관련한 모든 결과에 대해 스스로 책임을 져야 합니다.')}
          </Text>
          <Text mb={1}>
            {t('5. 본 서비스는 투자 결과를 보장하지 않으며, 어떠한 형태의 투자자문, 매매 권유 또는 리딩 행위에 해당하지 않습니다.')}
          </Text>
          <Text mb={1}>
            {t('6. 회원 상호 간 또는 제3자가 카피트레이딩(리딩)을 통해 전략·신호·포지션을 공유하거나 따르는 행위를 하더라도, 이는 전적으로 당사자 간 자율적 행위이며 회사는 이에 따른 손실, 법적 분쟁, 민형사상 문제에 대해 어떠한 책임도 지지 않습니다.')}
          </Text>
          <Text>
            {t('7. 회원은 카피트레이딩 또는 타인의 전략을 참고하여 발생한 모든 거래 결과에 대해 본인이 단독으로 책임을 집니다.')}
          </Text>
        </Box>

        {/* 제7조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제7조 (서비스 중단 및 종료)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회사는 정기점검, 시스템 업그레이드, 긴급 상황 등 불가피한 사유가 발생할 경우 사전 공지 후 서비스를 일시 중단할 수 있습니다.')}
          </Text>
          <Text>
            {t('2. 회사는 불가항력(천재지변, 전쟁, 정부의 규제 등) 또는 기술적 문제로 인한 서비스 중단으로 발생한 손해에 대해서도 책임을 지지 않습니다.')}
          </Text>
        </Box>

        {/* 제8조 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제8조 (기타사항)')}
          </Heading>
          <Text mb={1}>
            {t('1. 본 약관에 명시되지 않은 사항은 관련 법령 및 회사가 정한 내부 규정에 따릅니다.')}
          </Text>
          <Text>
            {t('2. 본 약관의 해석 및 적용에 관하여 분쟁이 발생할 경우, 회사의 본사 소재지를 관할하는 법원을 제1심 법원으로 합니다.')}
          </Text>
        </Box>

        {/* 제9조 - 개인정보 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제9조 (개인정보의 보호)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회사는 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하며, 「개인정보보호법」 등 관련 법령에 따라 안전하게 관리합니다.')}
          </Text>
          <Text>
            {t('2. 개인정보의 수집·이용 목적, 보유 및 이용기간, 제3자 제공 등에 관한 사항은 별도의 “개인정보처리방침”에 따릅니다.')}
          </Text>
        </Box>

        {/* 제10조 - 요금/환불(14일) */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제10조 (이용요금 및 환불)')}
          </Heading>
          <Text mb={1}>
            {t('1. 서비스 이용에 따른 요금, 결제 방법 및 환불 정책은 회사가 별도로 정하여 고지합니다.')}
          </Text>
          <Text mb={1}>
            {t('2. 회원이 유료 상품(자동매매 이용권, 플랜, 구독 등)을 구매한 경우, 결제일로부터 14일 이내에 환불을 요청할 수 있습니다.')}
          </Text>
          <Text mb={1}>
            {t('3. 다음 각 호의 경우 환불이 제한됩니다: ① 서비스의 특성상 이미 사용 또는 일부 이용한 경우, ② 이벤트·프로모션·할인 조건으로 제공된 경우, ③ 회원의 귀책 사유로 인한 결제 취소·철회가 불가능한 경우.')}
          </Text>
          <Text>
            {t('4. 환불은 회사의 내부 정책 및 결제수단 제공업체(결제대행사, 카드사 등)의 절차에 따라 진행되며, 처리 기간은 영업일 기준 7일 이내입니다.')}
          </Text>
        </Box>

        {/* 제11조 - 이용제한/해지 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제11조 (이용 제한 및 계약 해지)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회원이 다음 각 호의 행위를 한 경우 회사는 사전 통보 없이 서비스 이용을 제한하거나 계약을 해지할 수 있습니다: ① 타인의 정보 도용 또는 허위 정보로 가입한 경우, ② 서비스의 정상적인 운영을 방해한 경우, ③ 법령 또는 본 약관을 위반한 경우.')}
          </Text>
          <Text>
            {t('2. 회사는 이용 제한 또는 계약 해지 시 회원에게 이메일 등으로 통보합니다.')}
          </Text>
        </Box>

        {/* 제12조 - 지식재산권 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제12조 (지식재산권)')}
          </Heading>
          <Text mb={1}>
            {t('1. 서비스와 관련된 모든 저작물, 상표, 로고, 프로그램 등 지식재산권은 회사에 귀속됩니다.')}
          </Text>
          <Text>
            {t('2. 회원은 회사의 사전 서면 동의 없이 이를 복제, 배포, 판매, 임대, 공개, 변경하거나 역분석(Reverse Engineering)할 수 없습니다.')}
          </Text>
        </Box>

        {/* 제13조 - 약관 변경 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제13조 (약관의 변경)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회사는 필요 시 본 약관을 변경할 수 있으며, 변경 시 그 내용을 최소 7일 전(회원에게 불리하거나 중대한 변경의 경우 30일 전) 공지합니다.')}
          </Text>
          <Text>
            {t('2. 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴를 요청할 수 있습니다. 공지된 효력 발생일까지 이의가 없을 경우 변경 약관에 동의한 것으로 봅니다.')}
          </Text>
        </Box>

        {/* 제14조 - 고지수단/전자문서 */}
        <Box>
          <Heading as="h2" size="md" mb={2}>
            {t('제14조 (고지 방법 및 전자문서의 효력)')}
          </Heading>
          <Text mb={1}>
            {t('1. 회사의 공지는 홈페이지 공지사항, 이메일, 앱 푸시 등 합리적으로 선택한 수단으로 진행하며, 전자적 방법에 의한 고지는 서면 고지와 동일한 효력을 갖습니다.')}
          </Text>
          <Text>
            {t('2. 본 약관은 대한민국 법률에 따르며, 전자문서 및 전자거래에 관한 법률의 적용을 받습니다.')}
          </Text>
        </Box>
      </VStack>
    </Container>
  )
}

export default Terms
